import { render, staticRenderFns } from "./fccKanbanCard.vue?vue&type=template&id=79bb28db"
import script from "./fccKanbanCard.vue?vue&type=script&lang=js"
export * from "./fccKanbanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports